import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';

const ReviewCard = ({ review }) => (
  <div className="bg-white p-4 rounded-lg shadow-sm border border-gray-200 h-full flex flex-col">
    <div className="mb-2">
      <h3 className="font-semibold text-lg">{review.name}</h3>
      <p className="text-sm text-gray-500">{review.date}</p>
    </div>
    <p className="text-gray-700 mt-2 text-sm flex-grow">{review.text}</p>
  </div>
);

const Reviews = ({ reviews }) => {
  const [visibleReviews, setVisibleReviews] = useState(6);

  const loadMoreReviews = () => {
    setVisibleReviews(prevCount => prevCount + 6);
  };

  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
      <h2 className="text-2xl font-bold mb-4 sm:mb-6">Guestbook</h2>
      
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4">
        {reviews.slice(0, visibleReviews).map((review, index) => (
          <ReviewCard key={index} review={review} />
        ))}
      </div>

      {visibleReviews < reviews.length && (
        <button 
          onClick={loadMoreReviews}
          className="mt-4 sm:mt-6 w-full py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 transition-colors duration-200 flex items-center justify-center"
        >
          Show more entries
          <ChevronDown className="ml-2 w-5 h-5" />
        </button>
      )}
    </div>
  );
};

export default Reviews;